import styled from '@emotion/styled';
import classNames from 'classnames';
import { addMilliseconds, format, startOfToday } from 'date-fns';
import React from 'react';
import ReactPlayer from 'react-player';

import { SEVERITY } from 'constants/ChecklistConstants';

import type { VideoBookmark } from 'modules/medias/types/video-bookmark';

import * as style from './VideoPlayer.module.less';
import SeverityIconsBase from '../utils/SeverityIcons';

const SeverityIcons = styled(SeverityIconsBase)`
  font-size: 20px;
`;

type VideoPlayerType = {
  url: string;
  playing: boolean;
  onEnd: () => void;
  bookmarks: VideoBookmark[]
}

const VideoPlayer: React.FC<VideoPlayerType> = ({ bookmarks = [], url, playing, onEnd = () => undefined }) => {
  const videoRef = React.createRef<HTMLVideoElement>();
  const [ready, setReady] = React.useState(false);

  const hasBookmarks = bookmarks?.length > 0;

  const thumbnailsComponent = () =>
    bookmarks.map(bookmark => (
      <div
        key={bookmark.thumbnailPath}
        className={classNames(style.tile, {
          [`${style.disabled}`]: !ready,
        })}
        onClick={() => {
          if (ready) {
            videoRef.current!.currentTime = bookmark.time;
          }
        }}
      >
        <div
          style={{
            backgroundImage: `url('${bookmark.thumbnailPath}')`,
            backgroundPosition: 'center center',
            backgroundSize: 'cover',
            height: '100%',
            width: '100%',
          }}
        />
        <div className={style.time}>
          {[SEVERITY.HIGH, SEVERITY.LOW].includes(bookmark.type) && (
            <span className={style.icon}>
              <SeverityIcons severity={bookmark.type} />
            </span>
          )}
          {format(addMilliseconds(startOfToday(), bookmark.time * 1000), 'HH:mm:ss')}
        </div>
      </div>
    ));

  return (
    <div>
      <div className={style['video-container']}>
        <ReactPlayer
          src={url}
          controls
          width="auto"
          height="auto"
          ref={videoRef}
          playing={playing}
          disablePictureInPicture
          onEnded={() => onEnd()}
          onReady={() => setReady(true)}
          style={{ backgroundColor: 'black' }}
        />
      </div>
      {videoRef && hasBookmarks && (
        <div className={style['tile-container']}>
          <div className={style['tile-row']}>{thumbnailsComponent()}</div>
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;
